import { render, staticRenderFns } from "./dialog-save-user-role.vue?vue&type=template&id=41e100de&scoped=true&"
import script from "./dialog-save-user-role.vue?vue&type=script&lang=js&"
export * from "./dialog-save-user-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e100de",
  null
  
)

export default component.exports